<template>
    <div class="feedback-finish">
        <info-default
            :title="smallTitle"
            :descInfo="descInfo"
            imageUrl="svg"
            actionName="goReport"
            :textButton='$t("views.feedback.Finish.body[0]")'
            :noStyle="false">
            <Heart class="svg-icon"></Heart>
        </info-default>
    </div>
</template>
<script>
import InfoDefault from '../../components/Shared/InfoDefault.vue'
import Heart from '../../components/Shared/CustomIcons/Feedback/Heart'
import Bus from '../../main.js'
export default {
    components : {
        InfoDefault, Heart
    },
    data(){
        return{
            smallTitle : this.$t("views.feedback.Finish.body[1]"),
            title : this.$t("views.feedback.Finish.body[2]"),
            descInfo : this.$t("views.feedback.Finish.body[3]"),
        }
    },
    created(){
        Bus.$on('goReport', this.goReport)
    },
    destroyed(){
        Bus.$off('goReport')
    },
    methods: {
        goReport(){
            const gupyService = JSON.parse(localStorage.getItem("gupyServiceInfo"))
            gupyService ? this.routesParams.push({title: "Gupy Redirect", path: gupyService.callback_url}) : this.$router.push('/dashboard')            
        }
    }
}
</script>
<style lang="scss">
.svg-icon{
    min-width: 200px;
    margin: 0 0 32px;    
}
    @media only screen and (min-width: 750px){
        .feedback-finish{
            height: 100%;
        }
    }
@media screen and (max-width: 639px){
    .feedback-finish .info-default .info-container .title-info .shadow{
        top: -85px;
        left: 2px;
        font-weight: 900;
        line-height: 45px;                
    } 
}    
</style>
